// extracted by mini-css-extract-plugin
export var compactFilters = "_c8-4";
export var detailImage = "_c8-1";
export var dropdownContainer = "_c8-2";
export var imageContainer = "_c8-0";
export var selectedCard = "_c8-3";